import { deepCopy, currency, groupBy, ymdL } from '_u/helper'
import { formateLease, getResAmountText } from './u-contract'
import { contractBillCreate } from '@/api/contract'

// 合并相同的费用
function mergeBill(list) {
    const feeTypeObj = {}
    const newList = []
    list.forEach((v) => {
        if (feeTypeObj[v.feeType] === true) {
            const item = newList.find((p) => p.feeType === v.feeType)
            item.planAmount =
                parseFloat(item.planAmount) + parseFloat(v.planAmount)
        } else {
            newList.push(v)
            feeTypeObj[v.feeType] = true
        }
    })

    return newList
}

export default {
    methods: {
        // 生成合同账单
        createContractBill(formData) {
            formateLease(formData)
            if (
                formData.startDate &&
                formData.endDate &&
                formData.buildArea &&
                formData.unitPrice !== '' &&
                formData.rent !== '' &&
                formData.deposit !== '' &&
                formData.rentPayMethod &&
                formData.depositPayMethod &&
                formData.receiveRentType &&
                formData.receiveRentValue !== ''
            ) {
                this.billLoading = true

                contractBillCreate(formData)
                    .then((res) => {
                        const bills = deepCopy(res.data.list)
                        // 用于创建合同
                        bills.forEach((v) => {
                            Object.assign(v, {
                                title: `第${v.period}期`,
                                periodText: `${v.startDate} 至 ${v.endDate}`,
                                isChecked: false,
                                realDate: '',
                                payType: v.payType || '',
                                remark: '',
                            })
                            // 账单费用描述
                            // prettier-ignore
                            v.bill = `${this.dict.feeType.val(v.feeType)}：`
                            v.bill +=
                                v.billStatus === '2'
                                    ? currency(v.realAmount / 100)
                                    : currency(v.planAmount / 100)
                            v.bill += getResAmountText(v)
                            // 已收账单
                            if (v.billStatus === '2') {
                                v.realDate = ymdL(new Date())
                                v.isChecked = true
                            }
                        })
                        this.payBills = bills.filter(
                            (v) => v.billStatus === '3' || v.billStatus === '7'
                        )
                        this.bills = bills.filter(
                            (v) =>
                                v.billStatus === '1' ||
                                v.billStatus === '6' ||
                                v.billStatus === '2' // 新房抵扣场景会产生’已收‘账单
                        )

                        // 用于页面显示账单信息
                        const billView = []
                        // 过滤掉待付的账单-仅为不显示，生成合同依旧需要
                        const filterList = res.data.list.filter(
                            (v) => !v.sourceBillId
                        )
                        Object.values(groupBy(filterList, 'period')).forEach(
                            (g) => {
                                var first = g[0],
                                    bill = g.reduce((acc, v) => {
                                        // prettier-ignore
                                        let str = `${this.dict.feeType.val(v.feeType )}：`
                                        // 存在抵扣情况
                                        if (v.billStatus === '2') {
                                            // prettier-ignore
                                            str += `${currency(v.leftAmount / 100)}(${currency(v.realAmount / 100)}元${this.dict.payType.val(v.payType)})`
                                        } else {
                                            // prettier-ignore
                                            str += `${currency(v.planAmount / 100)}`
                                        }

                                        if (v.depositOffset === '1') {
                                            // prettier-ignore
                                            str += `\r\n(定抵押：${currency( v.offsetAmount / 100 )})`
                                        } else if (v.depositOffset === '2') {
                                            // prettier-ignore
                                            str += `\r\n(定抵租：${currency( v.offsetAmount / 100 )})`
                                        }
                                        acc += str + '\r\n'
                                        return acc
                                    }, '')
                                var date = g.reduce(
                                    (acc, v) => (acc += `${v.planDate}\r\n`),
                                    ''
                                )

                                billView.push({
                                    title: `第${first.period}期`,
                                    period: `${first.startDate} 至 ${first.endDate}`,
                                    bill,
                                    date,
                                })
                            }
                        )
                        this.billView = billView
                    })
                    .finally(() => {
                        this.billLoading = false
                    })
            }
        },
        // 标准化清算统计
        normalizeLiquidation(data) {
            var list = JSON.safeParse(data.liquidation) || [],
                remark = list[list.length - 1].remark,
                chargeDetails = []

            list.forEach((v) => {
                v.planAmount /= 100
            })
            // 费用清算-收款列表 pc isReceive,小程序 status
            var feeList = list.filter(
                (v) => v.isReceive === '1' || v.status === 'shou'
            )
            feeList = mergeBill(feeList)
            chargeDetails.push(
                ...this.normalizeChargeDetails(feeList, '实际收款费用')
            )
            //  费用清算-退款列表
            var paidList = list.filter(
                (v) => v.isReceive === '2' || v.status === 'tui'
            )
            paidList = mergeBill(paidList)
            chargeDetails.push(
                ...this.normalizeChargeDetails(paidList, '实际退款费用')
            )
            // 抄表费用
            var meterList = data.meters
            meterList.forEach((v) => {
                v.price /= 100
                v.amount /= 100
            })
            chargeDetails.push(
                ...this.normalizeChargeMeters(meterList, '抄表费用')
            )

            return {
                remark,
                chargeDetails,
            }
        },
        // 费用清算列表——收款退款
        normalizeChargeDetails(feeList, title) {
            var result = []
            if (feeList.length > 0) {
                const obj = {
                    title,
                    list: [],
                }
                // 一行5个数据
                let newItem = true
                feeList.forEach((v) => {
                    if (newItem) {
                        obj.list.push([])
                        newItem = false
                    }
                    obj.list[obj.list.length - 1].push({
                        text: this.dict.feeType.val(v.feeType),
                        val: currency(v.planAmount) + '元',
                    })
                    if (obj.list[obj.list.length - 1].length === 5) {
                        newItem = true
                    }
                })
                result.push(obj)
            }

            return result
        },
        // 费用清算列表——抄表
        normalizeChargeMeters(meterList, title) {
            var result = []
            if (meterList.length > 0) {
                const obj = {
                    title,
                    list: [],
                }

                meterList.forEach((v) => {
                    obj.list.push([
                        {
                            text: v.meterName,
                            val: '',
                        },
                        {
                            text: '上次读数',
                            val: v.lastDegree,
                        },
                        {
                            text: '本次读数',
                            val: v.degree,
                        },
                        {
                            text: '单价',
                            val: v.price,
                        },
                        {
                            text: '合计',
                            val: currency(v.amount) + '元',
                        },
                    ])
                })
                result.push(obj)
            }

            return result
        },
        // 合同是否存在清算明细
        checkLiquation(contract) {
            const { contractStatus } = contract
            return (
                contractStatus == '21' || // 退租中，待收款
                contractStatus == '22' || // 退租中，待确认
                contractStatus == '23' || // 退租中，待完成
                contractStatus == '25' || // 退租-到期
                contractStatus == '26' // 退租-违约
            )
        },
    },
}
